import { panelSnapshotPosts } from './PanelSnapshotPosts';

const storyCardSnapshot = {
    id: 'cGFuZWw6NjAwZWZjOWUzMzIwMTYwOGVlZGEzNjg5',
    partnerId: 1436,
    clientId: 8033,
    name: 'Story Card',
    description: '',
    publishTier: null,
    theme: {
        typography: {
            color: '',
            size: null,
            sizeLiteral: null,
            primary: {
                family: '',
                url: '',
                color: '',
                size: null,
                sizeLiteral: null,
                samId: null,
                name: null,
                description: null,
                subFamily: null,
                weight: null,
                style: null,
                textTransform: null,
            },
            secondary: {
                family: '',
                url: '',
                color: '',
                size: null,
                sizeLiteral: null,
                samId: null,
                name: null,
                description: null,
                subFamily: null,
                weight: null,
                style: null,
                textTransform: null,
            },
        },
        background: {
            url: '',
            size: '',
            repeat: '',
            color: '',
            position: '',
        },
        colorPalette: {
            type: '',
            solid: '',
            highlight: null,
            monochrome: {
                startColor: '',
                endOffset: null,
            },
            colorBlend: {
                startColor: '',
                endColor: '',
            },
            ranked: {
                colors: [],
                contrast: null,
            },
            overrides: [],
        },
    },
    storyboard: {
        id: 'c3Rvcnlib2FyZDo2MDA5MGNhZDcyN2FkYTM2MTc4YzU5MDA=',
        name: 'Story Card',
        pageNumber: {
            enabled: false,
            color: 'white',
            size: 10,
            alignment: 'right',
            showTotal: null,
        },
        watermark: {
            panelIndex: null,
            watermarkRendered: null,
            imageUrl: null,
        },
        imagesEnabled: true,
        videosEnabled: true,
        timePeriod: {
            key: 'last_7_days',
            duration: null,
            timeZone: 'America/Los_Angeles',
            startTime: 1610611200000,
            endTime: 1611215999999,
            xValue: null,
        },
    },
    scene: {
        id: 'c2NlbmU6NjAwZWZjOWUzMzIwMTYwOGVlZGEzNjg4',
        name: 'Scene 4',
        duration: 0,
        disabled: false,
        theme: null,
        sceneTransition: null,
    },
    widget: {
        children: [
            {
                children: null,
                id: 'id_hvu90zyjr',
                name: 'Story Card',
                type: 'storyCard',
                useGlobalTimePeriod: true,
                useGlobalDataSources: false,
                globalDataSourceName: null,
                css: null,
                js: null,
                options: {
                    player: {
                        playing: true,
                        duration: 6,
                        waitVideoEnd: false,
                    },
                    labelEnable: true,
                    labelTimeRangeSize: 16,
                    labelTimeRangeEnabled: false,
                    labelTimeRangeFormat: 'Pretty Time',
                    labelTimeZone: '',
                    animationLength: 1000,
                    animationDelay: 0,
                    animationType: 'fade',
                    animationEnabled: true,
                    animationVariation: 6,
                    widgetOrientation: 'landscape',
                    opacity: 100,
                    zIndex: 0,
                    locked: false,
                    sort: 'auto',
                    sortDirection: 'DESC',
                    sortHeading: '',
                    percentChangeFormat: '1k',
                    metricTimeRoundSeconds: false,
                    fontFamilySecondary: null,
                    fontFamilyPrimary: null,
                    fontSize: null,
                    colorFont: null,
                    showSocialColors: true,
                    metricThreshold: null,
                    showFullTimePeriod: false,
                    textFormat: '',
                    useThemeColor: false,
                    useThemeImage: false,
                    useThemeEmail: false,
                    themeEmailSize: 20,
                    themeImagePosition: null,
                    themeImageOpacity: 100,
                    themeImageCircleMask: true,
                    themeImageSize: 100,
                    barChartScale: 100,
                    showPostTextOverlayAsGradient: true,
                    classOverrides: {
                        postText: {
                            default: 'story_text_container p-reset p-0',
                        },
                        postInner: {
                            default: 'p-reset p-0',
                        },
                    },
                    postVersion: 2,
                    zeroFill: false,
                    zeroKill: false,
                    cumulative: false,
                    autoSizeWords: false,
                    invertDataSet: false,
                    showAdsMetrics: true,
                    metricValueCountup: {
                        enabled: true,
                        duration: 30,
                    },
                    showImageStyles: true,
                    imageFiltersOpen: true,
                    imageFilterBlur: false,
                    imageFilterBrightness: false,
                    imageFilterContrast: false,
                    imageFilterGrayscale: false,
                    imageFilterSaturate: false,
                    imageFilterHueRotate: false,
                    imageFilterOpacity: false,
                    imageFilterInvert: false,
                    imageFilterSepia: false,
                    imageFilterBlurValue: 0,
                    imageFilterBrightnessValue: 100,
                    imageFilterContrastValue: 100,
                    imageFilterGrayscaleValue: 0,
                    imageFilterSaturateValue: 100,
                    imageFilterHueRotateValue: 0,
                    imageFilterOpacityValue: 100,
                    imageFilterInvertValue: 0,
                    imageFilterSepiaValue: 0,
                    imageBlendMode: 'normal',
                    imageSecondaryBlendMode: '',
                    imageBlendColor: 'rgba(0,0,0,.3)',
                    imageSecondaryBlendColor: '',
                    presetImageFilters: '',
                    imageTextColor: '#FFF',
                    postImageTextSize: 10,
                    imagePostLineClamp: true,
                    imagePostLineClampValue: 3,
                    imagePostHideText: false,
                    imageFaceDetection: false,
                    hashtagTextColor: '',
                    hashtagBackgroundColor: '',
                    mentionTextColor: '',
                    mentionBackgroundColor: '',
                    urlTextColor: '',
                    urlBackgroundColor: '',
                    showTextEntityUrls: false,
                    showExpandedEntityUrls: false,
                    showEngagementMetrics: true,
                    engagementMetricsSize: 30,
                    engagementMetricsPosition: 'bottom_left',
                    adsMetricsSize: 30,
                    showTextStyles: false,
                    showText: true,
                    textOnlyColor: '#FFF',
                    postTextOnlySize: 10,
                    postLineClamp: true,
                    postLineClampValue: 3,
                    textFitMin: 20,
                    showPostTextOverlay: false,
                    showUserGroup: true,
                    showUserAvatar: true,
                    showUserName: true,
                    showUserScreenName: true,
                    userGroupIconSize: 10,
                    userGroupAvatarSize: 20,
                    userGroupNameSize: 20,
                    userGroupScreenNameSize: 16,
                    userGroupPosition: 'top',
                    userGroupGradientColor: 'rgba(0,0,0,.3)',
                    userGroupGradientEnabled: false,
                    userGroupGradientDirection: 'bottomToTop',
                    showTimeStamp: false,
                    timeStampSize: 15,
                    timeStampFormat: 'timeAgo',
                    endianTime: 'D MMM YYYY, h:mm a',
                    textOnlyBackgroundColor: '',
                    textOnlyTextFormat: 'fit',
                    textOnlyTeleprompterSpeed: 50,
                    postImageTextFormat: 'clamp',
                    postImageTeleprompterSpeed: 50,
                    imageBackgroundSize: 'cover',
                    showZeroEngagementValues: false,
                    maxCharacters: 180,
                    teleprompterSpeed: 50,
                    userGroupLayoutType: 'a',
                    postCompositionType: 'a',
                    socialIconBgColor: false,
                    customFields: {
                        fieldId: '',
                        size: 12,
                    },
                    location: {
                        enabled: false,
                        size: 15,
                    },
                    profanityFilter: {
                        enabled: false,
                        profanityList: [],
                        obscureSymbol: '*',
                        replace: false,
                        replaceList: {},
                    },
                    retweetIndicator: {
                        enabled: false,
                        opacity: 50,
                        size: 13,
                    },
                    reviews: {
                        enabled: false,
                        title: {
                            enabled: true,
                            color: '',
                            size: 17,
                            format: {
                                type: 'clamp',
                                clamp: {
                                    enabled: true,
                                    lines: 2,
                                },
                                fit: {
                                    min: 10,
                                    max: 400,
                                },
                            },
                        },
                        rating: {
                            enabled: true,
                            filledColor: '',
                            emptyColor: '',
                            size: 12,
                        },
                        product: {
                            enabled: true,
                            color: '',
                            size: 9,
                        },
                        message: {
                            enabled: true,
                            size: 13,
                            color: '',
                            format: {
                                type: 'clamp',
                                clamp: {
                                    enabled: true,
                                    lines: 5,
                                },
                                fit: {
                                    min: 20,
                                    max: 400,
                                },
                            },
                        },
                        domain: {
                            enabled: true,
                            color: '',
                            size: 9,
                        },
                    },
                    postTitleOptions: {
                        enabled: false,
                        size: 25,
                        color: '',
                        format: {
                            type: 'clamp',
                            clamp: {
                                enabled: true,
                                lines: 3,
                            },
                            fit: {
                                min: 20,
                                max: 400,
                            },
                        },
                    },
                    smartSize: {
                        enabled: true,
                        mode: 'responsive',
                        size: 'xl',
                    },
                    postComposition: 'a',
                    emoji: {
                        platform: 'default',
                    },
                    classes: 'rel',
                    secondaryOverlayColor: 'rgba(207, 180, 41, 0)',
                    gridLayout: {
                        gap: 10,
                        columns: 3,
                    },
                    storyOptions: {
                        space: 50,
                        title: {
                            enabled: true,
                            size: 65,
                            color: '',
                        },
                        summary: {
                            enabled: true,
                            size: 45,
                            color: '',
                        },
                        meta: {
                            enabled: true,
                            size: 45,
                            color: '',
                        },
                        metrics: {
                            enabled: true,
                            size: 45,
                            color: '',
                        },
                        publications: {
                            enabled: true,
                            size: 45,
                            color: '',
                        },
                        divider: {
                            enabled: true,
                            size: 10,
                            color: '',
                        },
                    },
                    postTemplate: 'card',
                    portrait: {
                        widgetOrientation: 'portrait',
                    },
                    smartSizeCompositions: {
                        baseline: {
                            space: 50,
                            gridLayout: {
                                gap: 10,
                            },
                            storyOptions: {
                                space: 50,
                                title: {
                                    size: 65,
                                },
                                meta: {
                                    size: 45,
                                },
                                summary: {
                                    size: 45,
                                },
                                publications: {
                                    size: 45,
                                },
                                divider: {
                                    size: 10,
                                },
                                metrics: {
                                    size: 45,
                                },
                            },
                        },
                        optionDefaults: {
                            imagePostLineClampValue: 3,
                            classOverrides: {
                                postText: {
                                    default: 'story_text_container p-reset p-0',
                                },
                                postInner: {
                                    default: 'p-reset p-0',
                                },
                            },
                        },
                        breakpoints: {
                            s: {
                                options: {
                                    classOverrides: {
                                        postText: {
                                            default: 'story_text_container p-reset p-0',
                                        },
                                        postInner: {
                                            default: 'p-reset p-0',
                                        },
                                    },
                                },
                            },
                        },
                    },
                    space: 50,
                },
                userAssetContentUrl: null,
                postRequests: [
                    {
                        sources: [
                            {
                                type: 'posts',
                                id: {
                                    columnType: null,
                                    columnId: null,
                                    reportingEngine: 'STORY_MESSAGE',
                                    report: 'STORY_MESSAGE',
                                    projections: [],
                                    sorts: [
                                        {
                                            order: 'DESC',
                                            heading: 'REACH',
                                        },
                                    ],
                                    filters: [
                                        {
                                            dimensionName: 'STORY_QUERY_ID',
                                            filterType: 'IN',
                                            values: ['5ffc2ba1873a9f230b7ead64'],
                                        },
                                    ],
                                    timePeriods: null,
                                    source: 'REPORTING',
                                    pageSize: 50,
                                    groupBys: [],
                                    timePeriod: {
                                        timeZone: 'America/Los_Angeles',
                                        key: 'last_7_days',
                                        duration: 1,
                                        startTime: 1611561600000,
                                        endTime: 1611647999999,
                                    },
                                    showInReplyToPost: false,
                                    useImagePlaceholder: false,
                                },
                                options: {
                                    count: 200,
                                    ordered: true,
                                    imagePreload: true,
                                    removeDuplicates: true,
                                    shufflePosts: false,
                                    includeFaceDetection: false,
                                },
                                data: [
                                    {
                                        dashboardId: '5edcb4ae5b2df765ae84376c',
                                        metrics: [
                                            {
                                                id: 'STORY_IMPACT',
                                                label: 'Impact',
                                                shortLabel: 'Impact',
                                                type: 'NUMBER',
                                                value: 33,
                                            },
                                            {
                                                id: 'IMPACT',
                                                label: 'Impact',
                                                shortLabel: 'Impact',
                                                type: 'NUMBER',
                                                value: 33,
                                            },
                                            {
                                                id: 'EMV',
                                                label: 'EMV',
                                                shortLabel: 'EMV',
                                                type: 'CURRENCY',
                                                value: 11400,
                                            },
                                            {
                                                id: 'INFLUENCE',
                                                label: 'Influence',
                                                shortLabel: 'Influence',
                                                type: 'NUMBER',
                                                value: 65,
                                            },
                                            {
                                                id: 'OVERALL_REACH',
                                                label: 'Overall Reach',
                                                shortLabel: 'Overall Reach',
                                                type: 'NUMBER',
                                                value: 16050053,
                                            },
                                        ],
                                        publicationEntity: [
                                            {
                                                id: 'overclockers.ru',
                                                name: 'overclockers.ru',
                                            },
                                            {
                                                id: 'donanimhaber.com',
                                                name: 'donanimhaber.com',
                                            },
                                            {
                                                id: 'hurriyet.com.tr',
                                                name: 'hurriyet.com.tr',
                                            },
                                            {
                                                id: 'attackofthefanboy.com',
                                                name: 'attackofthefanboy.com',
                                            },
                                        ],
                                        timeFilter: {
                                            sinceTime: 1610438076795,
                                            untilTime: 1611682307929,
                                            includeLower: true,
                                            includeUpper: true,
                                        },
                                        title: 'Activision Blizzard Valued at $72 billion',
                                        summary: [
                                            'With share prices for Activision Blizzard sitting at $94 – $95.',
                                            'They are currently at a multi-year high.',
                                        ],
                                        description:
                                            "Share Prices Rise to Higher Than They Were in the 80's   \nThe Wall Street Journal recently has recently reported that Activision Blizzard — publishers of popular franchises such as Warcraft and Call of Duty — is now valued at around about $72 billion. With share prices for Activision Blizzard sitting at $94 – $95, they are currently at a multi-year high, higher than share prices for Activision Blizzard have been since 1984. \n \nPart of Activision Blizzard’s success stems from the ongoing COVID-19 global health crisis as more people stay at home with nothing to do other than play one of the company’s many available titles. Another part surely comes from Activision Blizzard’s recent success with games such as Call of Duty: Mobile performing surprisingly well in the Chinese market. This boon has affected all games companies though as sales are up worldwide. In particular, microtransactions have proven to be a major revenue stream for companies, with microtransactions having made the company somewhere near $1.2 billion alone last quarter which is half of their total revenue. Additionally, Activision has done a good job of growing its previously shameful player base for Call of Duty on PC with their release of Warzone and Modern Warfare — which has greatly increased its PC player base ten times. \n \nThe games industry is certainly on the rise, and with this boon it might help fund better, more developed titles in the future. It’ll certainly be interesting to see how well Call of Duty Black Ops: Cold War has served the company after their next earnings report on February 4th.",
                                        lang: 'tr',
                                        langs: ['tr', 'ru', 'en'],
                                        imageUrl:
                                            'http://qa4-cdata-app.sprinklr.com/DAM/400002/unnamed_(1)-69f67e1e-9500-4967-9b9c-8a86996d6230-866493101_p.jpg',
                                        seedUm: {
                                            universalMessageId:
                                                'WEB_115_mov_BEC19F8E23B19017FCD90E5DEBF5A1F2',
                                            snCreatedTime: 1611303325000,
                                        },
                                        seedUmByLang: {
                                            tr: {
                                                universalMessageId:
                                                    'WEB_115_mov_BEC19F8E23B19017FCD90E5DEBF5A1F2',
                                                snCreatedTime: 1611303325000,
                                            },
                                            ru: {
                                                universalMessageId:
                                                    'WEB_115_mov_D86A48BA989235F97C5186958F7F2051',
                                                snCreatedTime: 1611322500000,
                                            },
                                            en: {
                                                universalMessageId:
                                                    'WEB_115_mov_EC7B0A25B3F8F16283A181ADAD0A11B8',
                                                snCreatedTime: 1611328825282,
                                            },
                                        },
                                        metricsHolder: {
                                            emv: 11400,
                                            impact: 33,
                                            influence: 65,
                                            reach: 16050053,
                                        },
                                        entities: {
                                            org: [],
                                            per: [],
                                        },
                                        category: 'Gaming',
                                        topDomains: [
                                            'overclockers.ru',
                                            'donanimhaber.com',
                                            'hurriyet.com.tr',
                                            'attackofthefanboy.com',
                                        ],
                                        seedUrl:
                                            'https://www.hurriyet.com.tr/teknoloji/activision-blizzardin-degeri-72-milyar-dolara-ulasti-41721573',
                                        countryCodes: ['US', 'TR', 'RU'],
                                        name: '600a82fcaa666e0001abec0e',
                                        projections: {
                                            REACH: {
                                                value: 9363642,
                                                origOrder: 1,
                                                additional: false,
                                                dataType: 'SUM',
                                            },
                                        },
                                        message: 'Activision Blizzard Valued at $72 billion',
                                        snStats: {},
                                        snMsgId: '600a82fcaa666e0001abec0e',
                                        extraPostData: [],
                                        projectionStats: [],
                                        images: [
                                            {
                                                type: 'PHOTO',
                                                url:
                                                    'http://qa4-cdata-app.sprinklr.com/DAM/400002/unnamed_(1)-69f67e1e-9500-4967-9b9c-8a86996d6230-866493101_p.jpg',
                                                poster: null,
                                                caption: null,
                                                description: null,
                                            },
                                        ],
                                        videos: [],
                                        unique: '600a82fcaa666e0001abec0e',
                                    },
                                    {
                                        dashboardId: '5edcb4ae5b2df765ae84376c',
                                        metrics: [
                                            {
                                                id: 'STORY_IMPACT',
                                                label: 'Impact',
                                                shortLabel: 'Impact',
                                                type: 'NUMBER',
                                                value: 75,
                                            },
                                            {
                                                id: 'IMPACT',
                                                label: 'Impact',
                                                shortLabel: 'Impact',
                                                type: 'NUMBER',
                                                value: 75,
                                            },
                                            {
                                                id: 'EMV',
                                                label: 'EMV',
                                                shortLabel: 'EMV',
                                                type: 'CURRENCY',
                                                value: 43303,
                                            },
                                            {
                                                id: 'INFLUENCE',
                                                label: 'Influence',
                                                shortLabel: 'Influence',
                                                type: 'NUMBER',
                                                value: 100,
                                            },
                                            {
                                                id: 'OVERALL_REACH',
                                                label: 'Overall Reach',
                                                shortLabel: 'Overall Reach',
                                                type: 'NUMBER',
                                                value: 77374373,
                                            },
                                        ],
                                        publicationEntity: [
                                            {
                                                id: 'comicbook.com',
                                                name: 'ComicBook',
                                                thumbnail:
                                                    'https://drive.google.com/open?id=15pr7X_tuBcS0EbgTwCNgnmmnLDVMPlZL',
                                            },
                                            {
                                                id: 'polygon.com',
                                                name: 'polygon.com',
                                            },
                                            {
                                                id: 'areajugones.sport.es',
                                                name: 'areajugones.sport.es',
                                            },
                                            {
                                                id: 'wccftech.com',
                                                name: 'wccftech.com',
                                            },
                                            {
                                                id: 'pushsquare.com',
                                                name: 'pushsquare.com',
                                            },
                                            {
                                                id: 'nintendolife.com',
                                                name: 'nintendolife.com',
                                            },
                                            {
                                                id: 'as.com',
                                                name: 'as.com',
                                            },
                                            {
                                                id: 'dontfeedthegamers.com',
                                                name: 'dontfeedthegamers.com',
                                            },
                                            {
                                                id: '3djuegos.com',
                                                name: '3djuegos.com',
                                            },
                                            {
                                                id: 'levelup.com',
                                                name: 'levelup.com',
                                            },
                                            {
                                                id: 'mmorpg.com',
                                                name: 'mmorpg.com',
                                            },
                                            {
                                                id: 'juegosadn.eleconomista.es',
                                                name: 'juegosadn.eleconomista.es',
                                            },
                                            {
                                                id: 'gry.interia.pl',
                                                name: 'gry.interia.pl',
                                            },
                                            {
                                                id: 'hobbyconsolas.com',
                                                name: 'hobbyconsolas.com',
                                            },
                                            {
                                                id: 'vandal.elespanol.com',
                                                name: 'vandal.elespanol.com',
                                            },
                                            {
                                                id: 'destructoid.com',
                                                name: 'destructoid.com',
                                            },
                                            {
                                                id: 'msn.com',
                                                name: 'MSN',
                                                thumbnail:
                                                    'https://pbs.twimg.com/profile_images/509007133283598338/-T4ohr0o_400x400.png',
                                            },
                                            {
                                                id: 'theverge.com',
                                                name: 'theverge.com',
                                            },
                                            {
                                                id: 'somagnews.com',
                                                name: 'somagnews.com',
                                            },
                                        ],
                                        timeFilter: {
                                            sinceTime: 1610484048976,
                                            untilTime: 1611682307929,
                                            includeLower: true,
                                            includeUpper: true,
                                        },
                                        title:
                                            'Vicarious Visions, maker of Tony Hawk and Crash Bandicoot remasters, merged into Blizzard',
                                        summary: [
                                            'The story was broken by GamesIndustry.biz which detailed the move in greater detail.',
                                            'That being said, a move of this nature between the two parties is somewhat unprecedented.',
                                        ],
                                        description:
                                            'Vicarious Visions, maker of Tony Hawk and Crash Bandicoot remasters, merged into Blizzard Vicarious Visions, the studio behind the recent Crash Bandicoot N. Sane Trilogy and Tony Hawk ’s Pro Skater 1 and 2 remasters, is now part of Blizzard Entertainment, reports GamesIndustry.biz . The studio has been merged with the developer behind World of Warcraft, Overwatch, and Diablo to provide “long-term support,” Blizzard said in a statement to GamesIndustry.\n© Image: Blizzard Entertainment Blizzard has been working with Vicarious Visions for some time, a representative for Blizzard said, but it’s not clear on which projects. Blizzard has a relatively high number of announced titles in development, including Diablo 4 , Overwatch 2 , and Diablo Immortal . None of those games have announced release dates, however.\nWe may know more about Blizzard’s plans — and how they involve Vicarious Visions’ more than 200 employees — soon. BlizzConline , an online-only version of the developer’s annual BlizzCon gaming convention, will take place Feb. 19-20.\nVicarious Visions was founded in 1990 and initially focused on titles for Game Boy and PC platforms. The company was acquired by Activision in 2005, and went on to develop games in the Guitar Hero, Transformers, Crash Bandicoot, Tony Hawk’s Pro Skater, and Skylanders franchises. Vicarious Visions studio head Jennifer Oneal has been promoted to executive vice president of development at Blizzard, and will report to Blizzard president J. Allen Brack.',
                                        lang: 'en',
                                        langs: ['en', 'es', 'pl'],
                                        imageUrl:
                                            'http://qa4-cdata-app.sprinklr.com/DAM/400002/unnamed_(1)-69f67e1e-9500-4967-9b9c-8a86996d6230-866493101_p.jpg',
                                        seedUm: {
                                            universalMessageId:
                                                'WEB_115_de264edc7718812c8d482f805e6c2862',
                                            snCreatedTime: 1611364544956,
                                        },
                                        seedUmByLang: {
                                            en: {
                                                universalMessageId:
                                                    'WEB_115_de264edc7718812c8d482f805e6c2862',
                                                snCreatedTime: 1611364544956,
                                            },
                                            es: {
                                                universalMessageId:
                                                    'WEB_115_mov_86BA3A8F65590E8F613F893E80E35D34',
                                                snCreatedTime: 1611349599000,
                                            },
                                            pl: {
                                                universalMessageId:
                                                    'WEB_115_mov_6FBAC5FDDA8090EFFA95E9117C7C23F2',
                                                snCreatedTime: 1611599376000,
                                            },
                                        },
                                        metricsHolder: {
                                            emv: 43303,
                                            impact: 75,
                                            influence: 100,
                                            reach: 77374373,
                                        },
                                        entities: {
                                            org: [],
                                            per: [],
                                        },
                                        category: 'Gaming',
                                        topDomains: [
                                            'comicbook.com',
                                            'polygon.com',
                                            'areajugones.sport.es',
                                            'wccftech.com',
                                            'pushsquare.com',
                                            'nintendolife.com',
                                            'as.com',
                                            'dontfeedthegamers.com',
                                            '3djuegos.com',
                                            'levelup.com',
                                            'mmorpg.com',
                                            'juegosadn.eleconomista.es',
                                            'gry.interia.pl',
                                            'hobbyconsolas.com',
                                            'vandal.elespanol.com',
                                            'destructoid.com',
                                            'msn.com',
                                            'theverge.com',
                                            'somagnews.com',
                                        ],
                                        seedUrl:
                                            'https://www.msn.com/en-us/entertainment/gaming/vicarious-visions-maker-of-tony-hawk-and-crash-bandicoot-remasters-merged-into-blizzard/ar-BB1d0vHJ',
                                        countryCodes: ['MX', 'UN', 'ES', 'GB', 'PL', 'US', 'CA'],
                                        name: '600b36564f363d00014ffd0c',
                                        projections: {
                                            REACH: {
                                                value: 9111397,
                                                origOrder: 1,
                                                additional: false,
                                                dataType: 'SUM',
                                            },
                                        },
                                        message:
                                            'Vicarious Visions, maker of Tony Hawk and Crash Bandicoot remasters, merged into Blizzard',
                                        snStats: {},
                                        snMsgId: '600b36564f363d00014ffd0c',
                                        extraPostData: [],
                                        projectionStats: [],
                                        images: [
                                            {
                                                type: 'PHOTO',
                                                url:
                                                    'http://qa4-cdata-app.sprinklr.com/DAM/400002/unnamed_(1)-69f67e1e-9500-4967-9b9c-8a86996d6230-866493101_p.jpg',
                                                poster: null,
                                                caption: null,
                                                description: null,
                                            },
                                        ],
                                        videos: [],
                                        unique: '600b36564f363d00014ffd0c',
                                    },
                                    {
                                        dashboardId: '5edcb4ae5b2df765ae84376c',
                                        metrics: [
                                            {
                                                id: 'STORY_IMPACT',
                                                label: 'Impact',
                                                shortLabel: 'Impact',
                                                type: 'NUMBER',
                                                value: 56,
                                            },
                                            {
                                                id: 'IMPACT',
                                                label: 'Impact',
                                                shortLabel: 'Impact',
                                                type: 'NUMBER',
                                                value: 56,
                                            },
                                            {
                                                id: 'EMV',
                                                label: 'EMV',
                                                shortLabel: 'EMV',
                                                type: 'CURRENCY',
                                                value: 45950,
                                            },
                                            {
                                                id: 'INFLUENCE',
                                                label: 'Influence',
                                                shortLabel: 'Influence',
                                                type: 'NUMBER',
                                                value: 100,
                                            },
                                            {
                                                id: 'OVERALL_REACH',
                                                label: 'Overall Reach',
                                                shortLabel: 'Overall Reach',
                                                type: 'NUMBER',
                                                value: 51527948,
                                            },
                                        ],
                                        publicationEntity: [
                                            {
                                                id: 'arstechnica.com',
                                                name: 'arstechnica.com',
                                            },
                                            {
                                                id: 'tech.hindustantimes.com',
                                                name: 'tech.hindustantimes.com',
                                            },
                                            {
                                                id: 'infobae.com',
                                                name: 'infobae.com',
                                            },
                                            {
                                                id: 'gadgets.ndtv.com',
                                                name: 'NDTV Gadgets',
                                                thumbnail:
                                                    'https://cdn.gadgets360.com/gadgets360_logo.png',
                                            },
                                            {
                                                id: 'bnnbloomberg.ca',
                                                name: 'bnnbloomberg.ca',
                                            },
                                            {
                                                id: 'bloombergquint.com',
                                                name: 'bloombergquint.com',
                                            },
                                            {
                                                id: 'ca.finance.yahoo.com',
                                                name: 'Yahoo Finance Canada',
                                                thumbnail:
                                                    'https://pbs.twimg.com/profile_images/1176189557450203141/5cpwV6oD_400x400.png',
                                            },
                                            {
                                                id: 'finance.yahoo.com',
                                                name: 'Yahoo Finance',
                                                thumbnail:
                                                    'https://pbs.twimg.com/profile_images/1176105064219516928/qwU6ALZR_400x400.png',
                                            },
                                        ],
                                        timeFilter: {
                                            sinceTime: 1610489326575,
                                            untilTime: 1611682307929,
                                            includeLower: true,
                                            includeUpper: true,
                                        },
                                        title:
                                            'Blizzard Absorbs Activision Studio After Dismantling Classic Games Team',
                                        summary: [
                                            "In fact, Vicarious Visions' website is currently offline altogether.",
                                            'Really, because we felt that Blizzard really got us and got [ Diablo 1 ].',
                                        ],
                                        description:
                                            "(Bloomberg) -- Video game publisher Activision Blizzard Inc. took another step in consolidating control over division Blizzard Entertainment, which once took pride in its autonomy, by shifting a 200-person design studio to its ranks. The studio, Vicarious Visions, had been a subsidiary of Activision since 2005 and worked on franchises like Skylanders, Crash Bandicoot and Tony Hawk. It will now focus entirely on Blizzard’s franchises, including Diablo, instead of making its own games. Former Vicarious Visions studio head Jennifer Oneal will take a seat on Blizzard's leadership team, reporting directly to the president.The news, reported by GamesIndustry.biz, arrived just a few weeks after Blizzard quietly dismantled one of its internal development teams, according to people familiar with the company. \n\nBlizzard, the maker of games like World of Warcraft and Overwatch, has traditionally developed most of its games in-house. But in recent years, the Activision publishing arm has taken a stronger hand in Blizzard’s operations. Vicarious Visions, based in Albany, New York, has been working with Blizzard since last year on the Diablo franchise, including a planned remake of Diablo II, people familiar with the plans said. They asked not to be identified discussing private information. \n\nA Blizzard spokesman declined to comment on Vicarious Visions’ current projects, only confirming that the studio “has been working with Blizzard for some time.” \n\nUntil last year, the Diablo II remake was set to be developed by Blizzard’s Team 1, part of the company’s Irvine, California, campus that had become known for reworking classic games. Its most recent release, in January 2020, was a remake called Warcraft III: Reforged. The title was poorly received due to glitches and missing features, earning 59 out of 100 points on the review aggregator Metacritic — the lowest score a Blizzard game has ever gotten. \n\nMembers of Team 1 met to discuss what had gone wrong. Internal Blizzard documents reviewed by Bloomberg pinpointed the game’s failures on poor planning, miscommunication and a rushed release due to financial pressure from management, among other factors. For example, Blizzard announced the game in November 2018 and began taking pre-orders for 2019 without informing most of the development team beforehand, according to several people who worked on Warcraft III: Reforged. \n\nTeam 1 wanted to avoid repeating the mistakes of Warcraft III: Reforged on its next project, the remake of Diablo II. Shortly after the postmortem, however, Blizzard pulled that project from the team and put the division behind Diablo IV in charge. A group at Vicarious Visions is also working on the remake, which was known as Diablo II: Resurrected. \n\nOn Oct. 15, 2020, Blizzard informed members of Team 1 that it was reorganizing the entire division, according to the people who worked on Warcraft III: Reforged. In the following weeks, members of the team were given opportunities to interview for jobs elsewhere within Blizzard. Those who did not find positions in the company were gradually cut. Others left for independent studios recently started by high-profile company veterans, such as Frost Giant Inc. and DreamHaven Inc., started by Blizzard co-founder and former Chief Executive Officer Mike Morhaime, whose departure widely signaled the beginning of Activision's takeover. \n\nTeam 1 was also responsible for the games Heroes of the Storm and StarCraft II. Blizzard ended development support of Heroes of the Storm in 2018. On the same day that Blizzard said it was reorganizing the division, it announced publicly that StarCraft II was ending all ongoing development. \n\nBlizzard has promised to continue fixing and updating Warcraft III: Reforged, although it will likely do it with a different outsourced team. A spokesperson wouldn’t confirm who is handling continued development of Warcraft III: Reforged but said “we are still committed to updates in support of the community.” \n\n©2021 Bloomberg L.P.",
                                        lang: 'en',
                                        langs: ['en', 'es'],
                                        imageUrl:
                                            'http://qa4-cdata-app.sprinklr.com/DAM/400002/unnamed_(1)-69f67e1e-9500-4967-9b9c-8a86996d6230-866493101_p.jpg',
                                        seedUm: {
                                            universalMessageId:
                                                'WEB_115_mov_D5B465C8A76106C2B6DF8F958E5034B0',
                                            snCreatedTime: 1611360023000,
                                        },
                                        seedUmByLang: {
                                            en: {
                                                universalMessageId:
                                                    'WEB_115_mov_D5B465C8A76106C2B6DF8F958E5034B0',
                                                snCreatedTime: 1611360023000,
                                            },
                                            es: {
                                                universalMessageId:
                                                    'WEB_115_mov_8C960E2D1630844DD13615998A7DB3EE',
                                                snCreatedTime: 1611359702000,
                                            },
                                        },
                                        metricsHolder: {
                                            emv: 45950,
                                            impact: 56,
                                            influence: 100,
                                            reach: 51527948,
                                        },
                                        entities: {
                                            org: [],
                                            per: [],
                                        },
                                        category: 'Gaming',
                                        topDomains: [
                                            'arstechnica.com',
                                            'tech.hindustantimes.com',
                                            'infobae.com',
                                            'gadgets.ndtv.com',
                                            'bnnbloomberg.ca',
                                            'bloombergquint.com',
                                            'ca.finance.yahoo.com',
                                            'finance.yahoo.com',
                                        ],
                                        seedUrl: 'https://arstechnica.com/?p=1736905',
                                        countryCodes: ['US', 'CA', 'IN', 'AR', 'UN'],
                                        name: '600b4b954f363d0001504f47',
                                        projections: {
                                            REACH: {
                                                value: 8538467,
                                                origOrder: 1,
                                                additional: false,
                                                dataType: 'SUM',
                                            },
                                        },
                                        message:
                                            'Blizzard Absorbs Activision Studio After Dismantling Classic Games Team',
                                        snStats: {},
                                        snMsgId: '600b4b954f363d0001504f47',
                                        extraPostData: [],
                                        projectionStats: [],
                                        images: [
                                            {
                                                type: 'PHOTO',
                                                url:
                                                    'http://qa4-cdata-app.sprinklr.com/DAM/400002/unnamed_(1)-69f67e1e-9500-4967-9b9c-8a86996d6230-866493101_p.jpg',
                                                poster: null,
                                                caption: null,
                                                description: null,
                                            },
                                        ],
                                        videos: [],
                                        unique: '600b4b954f363d0001504f47',
                                    },
                                ],
                            },
                        ],
                        format: {
                            type: 'buckets',
                            options: {
                                padding: 1,
                                buckets: {
                                    any: {
                                        filter: 'post.type',
                                    },
                                },
                                panels: [
                                    {
                                        total: 3,
                                        buckets: ['any', -1],
                                    },
                                ],
                            },
                        },
                        showInReplyToPost: false,
                    },
                ],
                classes: null,
                theme: {
                    colorFont: null,
                    colorPrimary: null,
                    colorSecondary: null,
                    colorBackground: null,
                    colorNegative: null,
                    colorPostive: null,
                    ext: {
                        padding: 40,
                        gridLayoutColumns: 5,
                        gridLayoutRows: 5,
                        showGuides: false,
                        colorGrid: 'rgb(55, 55, 65)',
                        showGridLayout: false,
                        snapToGrid: false,
                        gutter: 20,
                    },
                    fontFamilyPrimary: null,
                    fontFamilySecondary: null,
                    fontSizePrimary: null,
                    fontSizeSecondary: null,
                    fontPrimary: null,
                    fontSecondary: null,
                    backgroundImage: null,
                    typography: {
                        color: '',
                        size: null,
                        sizeLiteral: null,
                        primary: {
                            family: '',
                            url: '',
                            color: '',
                            size: null,
                            sizeLiteral: null,
                            samId: null,
                            name: null,
                            description: null,
                            subFamily: null,
                            weight: null,
                            style: null,
                            textTransform: null,
                        },
                        secondary: {
                            family: '',
                            url: '',
                            color: '',
                            size: null,
                            sizeLiteral: null,
                            samId: null,
                            name: null,
                            description: null,
                            subFamily: null,
                            weight: null,
                            style: null,
                            textTransform: null,
                        },
                    },
                    background: {
                        url: '',
                        size: '',
                        repeat: '',
                        color: '',
                        position: '',
                    },
                    colorPalette: {
                        type: '',
                        solid: '',
                        highlight: null,
                        monochrome: {
                            startColor: '',
                            endOffset: null,
                        },
                        colorBlend: {
                            startColor: '',
                            endColor: '',
                        },
                        ranked: {
                            colors: [],
                            contrast: null,
                        },
                        overrides: [],
                    },
                },
                position: {
                    left: '0px',
                    right: null,
                    top: '0px',
                    bottom: null,
                    width: '100%',
                    height: '100%',
                    portrait: null,
                    landscape: null,
                    backgroundColor: null,
                    display: null,
                    maxWidth: null,
                    maxHeight: null,
                },
                analyticsRequests: null,
                analyticsResults: null,
                profileRequests: null,
                profileResults: null,
                trendRequests: null,
                label: {
                    titleText: 'Story Card',
                    subTitleText: null,
                    classes: null,
                    overlap: false,
                    layout: 'flex no-grow vertical left',
                    icon: null,
                    enabled: false,
                    size: 20,
                },
            },
        ],
        id: '1',
        name: null,
        type: null,
        useGlobalTimePeriod: true,
        useGlobalDataSources: false,
        globalDataSourceName: null,
        css: null,
        js: null,
        options: {
            player: {
                playing: false,
                duration: 15,
                waitVideoEnd: false,
            },
            labelEnable: true,
            labelTimeRangeSize: 16,
            labelTimeRangeEnabled: false,
            labelTimeRangeFormat: 'Pretty Time',
            labelTimeZone: '',
            animationLength: 1000,
            animationDelay: 0,
            animationType: 'fade',
            animationEnabled: true,
            animationVariation: 6,
            widgetOrientation: 'landscape',
            opacity: 100,
            zIndex: 0,
            locked: false,
            sort: 'auto',
            sortDirection: 'DESC',
            sortHeading: '',
            percentChangeFormat: '1k',
            metricTimeRoundSeconds: false,
            fontFamilySecondary: null,
            fontFamilyPrimary: null,
            fontSize: null,
            colorFont: null,
            showSocialColors: true,
            metricThreshold: null,
            showFullTimePeriod: false,
            textFormat: '',
            useThemeColor: false,
            useThemeImage: false,
            useThemeEmail: false,
            themeEmailSize: 20,
            themeImagePosition: null,
            themeImageOpacity: 100,
            themeImageCircleMask: true,
            themeImageSize: 100,
            barChartScale: 100,
            showPostTextOverlayAsGradient: false,
            classOverrides: {},
            postVersion: 1,
            zeroFill: false,
            zeroKill: false,
            cumulative: false,
            autoSizeWords: false,
            invertDataSet: false,
            showAdsMetrics: false,
            metricValueCountup: {
                enabled: true,
                duration: 30,
            },
        },
        userAssetContentUrl: null,
        postRequests: null,
        classes: 'template_story_card',
        theme: {
            colorFont: null,
            colorPrimary: null,
            colorSecondary: null,
            colorBackground: null,
            colorNegative: null,
            colorPostive: null,
            ext: {
                padding: 15,
                gridLayoutColumns: 5,
                gridLayoutRows: 5,
                showGuides: false,
                colorGrid: 'rgb(55, 55, 65)',
                showGridLayout: false,
                snapToGrid: false,
                gutter: 20,
            },
            fontFamilyPrimary: null,
            fontFamilySecondary: null,
            fontSizePrimary: null,
            fontSizeSecondary: null,
            fontPrimary: null,
            fontSecondary: null,
            backgroundImage: null,
            typography: {
                color: '',
                size: null,
                sizeLiteral: null,
                primary: {
                    family: '',
                    url: '',
                    color: '',
                    size: null,
                    sizeLiteral: null,
                    samId: null,
                    name: null,
                    description: null,
                    subFamily: null,
                    weight: null,
                    style: null,
                    textTransform: null,
                },
                secondary: {
                    family: '',
                    url: '',
                    color: '',
                    size: null,
                    sizeLiteral: null,
                    samId: null,
                    name: null,
                    description: null,
                    subFamily: null,
                    weight: null,
                    style: null,
                    textTransform: null,
                },
            },
            background: {
                url: '',
                size: '',
                repeat: '',
                color: '',
                position: '',
            },
            colorPalette: {
                type: '',
                solid: '',
                highlight: null,
                monochrome: {
                    startColor: '',
                    endOffset: null,
                },
                colorBlend: {
                    startColor: '',
                    endColor: '',
                },
                ranked: {
                    colors: [],
                    contrast: null,
                },
                overrides: [],
            },
        },
        position: {
            left: '0',
            right: null,
            top: '0',
            bottom: null,
            width: '1920px',
            height: '1080px',
            portrait: null,
            landscape: null,
            backgroundColor: null,
            display: null,
            maxWidth: null,
            maxHeight: null,
        },
        analyticsRequests: null,
        analyticsResults: null,
        profileRequests: null,
        profileResults: null,
        trendRequests: null,
        label: {
            titleText: 'Header',
            subTitleText: null,
            classes: null,
            overlap: false,
            layout: 'flex no-grow vertical left',
            icon: null,
            enabled: false,
            size: 20,
        },
    },
    screenIndex: 0,
    sceneIndex: 0,
    dataLastModified: 1611620257387,
};
export default storyCardSnapshot;
